import { compose } from 'redux';

import { LayoutDefault } from './Layout';

const defaultHOCs = compose(LayoutDefault);

export default defaultHOCs;
